import { Static, Object, String, Optional } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';

import { TravelPassApiError } from './error';
import { AirportCode } from './travel-pass';

export const TravelPassAirportLocation = Object({
  airportCode: AirportCode,
  airportName: String(),
  cityCode: String(),
  cityName: String(),
  countryCode: String(),
  countryName: String(),
});
export type TravelPassAirportLocation = Static<typeof TravelPassAirportLocation>;

export const TravelPassAirportsQuery = Object({
  origin: AirportCode,
  destination: AirportCode,
});
export type TravelPassAirportsQuery = Static<typeof TravelPassAirportsQuery>;

export const TravelPassAirportsError = TravelPassApiError(UnionEnum(['invalid-request']));
export type TravelPassAirportsError = Static<typeof TravelPassAirportsError>;

export const TravelPassAirportsResponse = Object({
  origin: Optional(TravelPassAirportLocation),
  destination: Optional(TravelPassAirportLocation),
});
export type TravelPassAirportsResponse = Static<typeof TravelPassAirportsResponse>;
